import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import VirtualTransactionsDownload2ModalUI from './VirtualTransactionsDownLoad2ModalUI'

class VirtualTransactionsDownload2ModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      format: 'pdf',
      formatError: null,

      fromYear: null,
      fromYearError: null,
      fromMonth: null,
      fromMonthError: null,
      toYear: null,
      toYearError: null,
      toMonth: null,
      toMonthError: null
    }
  }

  render() {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth() + 1
    const monthNames = ['January', 'Feburary', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December']

    let yearList = []
    for (let year = 2025; year <= currentYear; year += 1) {
      yearList.push({ key: String(year), value: String(year) })
    }

    const selectedFromYear = Number(this.state.fromYear)
    const selectedToYear = Number(this.state.toYear)
    const fromMaxMonth = selectedFromYear === currentYear ? currentMonth : 12
    const toMaxMonth = selectedToYear === currentYear ? currentMonth : 12
    let fromMonthList = []
    let toMonthList = []
    for (let month = 1; month <= fromMaxMonth; month += 1) {
      fromMonthList.push({ key: String(month), value: monthNames[month - 1] })
    }
    for (let month = 1; month <= toMaxMonth; month += 1) {
      toMonthList.push({ key: String(month), value: monthNames[month - 1] })
    }

    let formatList = [
      { key: 'pdf', value: 'PDF' },
      { key: 'excel', value: 'Excel' }
    ]
    return (
      <VirtualTransactionsDownload2ModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        bankAccountNumber={this.props.bankAccountNumber}
        formatList={formatList}

        format={this.state.format}
        onFormatChange={(event) => { this.setState({ format: event.target.value }) }}
        formatError={this.state.formatError}
        setFormatError={(error) => { this.setState({ formatError: error }) }}

        fromYearList={yearList}
        fromYear={this.state.fromYear}
        onFromYearChange={(event) => { this.setState({ fromYear: event.target.value, fromMonth: null }) }}
        fromYearError={this.state.fromYearError}
        setFromYearError={(error) => { this.setState({ fromYearError: error }) }}

        fromMonthList={fromMonthList}
        fromMonth={this.state.fromMonth}
        onFromMonthChange={(event) => { this.setState({ fromMonth: event.target.value }) }}
        fromMonthError={this.state.fromMonthError}
        setFromMonthError={(error) => { this.setState({ fromMonthError: error }) }}

        toYearList={yearList}
        toYear={this.state.toYear}
        onToYearChange={(event) => { this.setState({ toYear: event.target.value, toMonth: null }) }}
        toYearError={this.state.toYearError}
        setToYearError={(error) => { this.setState({ toYearError: error }) }}

        toMonthList={toMonthList}
        toMonth={this.state.toMonth}
        onToMonthChange={(event) => { this.setState({ toMonth: event.target.value }) }}
        toMonthError={this.state.toMonthError}
        setToMonthError={(error) => { this.setState({ toMonthError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    // Validate from and to year-month
    let errorList = []
    if ((this.state.fromYear === null || this.state.fromYear === '') &&
      (this.state.fromMonth === null || this.state.fromMonth === '')) {
      errorList.push("Please select From year and month")
    } else if (this.state.fromYear === null || this.state.fromYear === '') {
      errorList.push("Please select From year")
    } else if (this.state.fromMonth === null || this.state.fromMonth === '') {
      errorList.push("Please select From month")
    }

    if ((this.state.toYear === null || this.state.toYear === '') &&
      (this.state.toMonth === null || this.state.toMonth === '')) {
      errorList.push("Please select To year and month")
    } else if (this.state.toYear === null || this.state.toYear === '') {
      errorList.push("Please select To year")
    } else if (this.state.toMonth === null || this.state.toMonth === '') {
      errorList.push("Please select To month")
    }

    if (errorList.length > 0) {
      this.setState({
        errorList: errorList
      })
      return
    }

    const selectedFromYear = Number(this.state.fromYear)
    const selectedFromMonth = Number(this.state.fromMonth)
    const selectedToYear = Number(this.state.toYear)
    const selectedToMonth = Number(this.state.toMonth)
    const startDate = new Date(selectedFromYear, selectedFromMonth - 1, 1)
    const endDate = new Date(selectedToYear, selectedToMonth, 0)
    if (startDate > endDate) {
      this.setState({
        errorList: ["From month must be before or equal to To month"]
      })
      return
    }
    const startDateISO = this.toLocalISODate(startDate)
    const endDateISO = this.toLocalISODate(endDate)

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/virtualAccounts/${this.props.bankAccountNumber}/transactions/fileDownloadSignedUrl`,
      this.onSubmitCallback, null, {
      // year: selectedFromYear,
      startDate: startDateISO,
      endDate: endDateISO,
      period: this.props.period,
      format: this.state.format
    }
    )
  }

  toLocalISODate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default VirtualTransactionsDownload2ModalSF
